/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2026-01-14 21:24:18
 */

import React from 'react'
import { Result } from 'antd'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../../app/hooks'

const NotAdminPage = () => {
  return (
    <div className="result-page-wrapper">
      <Result
        status="warning"
        title="您不是管理员，无权限查看此页面。"
        subTitle="请联系当前团队的管理员，将您设置为管理员之后查看。"
        extra={[
          <p key="0">
            （备注：在今日水印相机APP上，点击我的团队，打开成员列表页面，可以查看到当前的管理员。）
          </p>
        ]}
      />
    </div>
  )
}

const AuthPolicyWrapper = ({ children }) => {
  const location = useLocation()
  const pathname = location.pathname
  const groupAuthPolicy = useAppSelector((state) => state.group.groupAuthPolicy)

  if (!groupAuthPolicy) {
    return <NotAdminPage />
  }

  if (pathname === '/customer/info') {
    const userPolicy = groupAuthPolicy.policyList.find((policy) => {
      return (
        policy.policyType === 2 &&
        policy.source === 4 &&
        policy.action === 'read'
      )
    })
    return userPolicy ? children : <NotAdminPage />
  }
  if (pathname === '/visit/record') {
    const userPolicy = groupAuthPolicy.policyList.find((policy) => {
      return (
        policy.policyType === 2 &&
        policy.source === 5 &&
        policy.action === 'read'
      )
    })
    return userPolicy ? children : <NotAdminPage />
  }
  return <NotAdminPage />
}

export default AuthPolicyWrapper
